module.exports = __webpack_public_path__ + "img/mobile/Menus-landscape/switch_icon@2x.png?0.0.53";